<template>
    <b-form :id="`tranche-form-${_uid}`" @submit.stop.prevent="patchCreateTranche($event)">

        <DeleteConfirmButton
                v-if="!isNew()"
                style="float: right;margin: 11px"
                message="Supprimer le dossier"
                title="Supprimer le dossier"
                @confirmed="archiveTranche()"/>

        <br style="clear: both" v-if="!isNew()">

        <!-- Date AMEO -->
        <b-form-group label="Date AMEO*" label-cols="2">
          <date-picker v-model="tranche.ameoDate"
                        :config="config"
                        placeholder="JJ/MM/AAAA"
                        class="tranche-date-picker"
                        :class="(!ameoDateValid ? 'is-invalid' : '')">
          </date-picker>
        </b-form-group>

        <!-- Reception date -->
        <b-form-group label="Date de réception" label-cols="2">
          <date-picker v-model="tranche.receptionDate"
                :config="config"
                placeholder="JJ/MM/AAAA"
                class="tranche-date-picker">
          </date-picker>
        </b-form-group>

        <!-- Case Manager -->
        <b-form-group label="Chargé d'affaire*" label-cols="2">
          <b-form-select v-model="tranche.caseManager" :id="`tranche-case-manager-${_uid}`" :class="(!caseManagerValid ? 'is-invalid' : '')">
            <option :value="null" :selected="tranche.caseManager == null">-- Merci de choisir un chargé d'affaire --</option>
            <option v-for="(caseManager, index) in caseManagers" :value="caseManager" :key="index">
              {{ formatCaseManagerName(caseManager) }}
            </option>
          </b-form-select>
        </b-form-group>

        <!-- Agency -->
        <b-form-group label="Agence*" label-cols="2">
          <b-form-select v-model="tranche.agency" :id="`tranche-case-manager-${_uid}`" :class="(!agencyValid ? 'is-invalid' : '')">
            <option :value="null">-- Merci de choisir une agence --</option>
            <option v-for="(agency, index) in agencies" :value="agency.id" :key="index">
              {{ agency.type }} - {{ agency.name }}
            </option>
          </b-form-select>
        </b-form-group>

        <!-- PalRro -->
        <div id="checkboxGroup">
          <b-form-checkbox v-model="tranche.palRro" :id="`tranche-pal-rro-${_uid}`">PAL RRO</b-form-checkbox>
          <b-form-checkbox v-model="tranche.classA" :id="`tranche-class-a-${_uid}`">Classe A</b-form-checkbox>
        </div>

        <!-- Date completeness -->
        <b-form-group label="Date de complétude du dossier">
          <date-picker v-model="tranche.completeDate"
                :config="config"
                placeholder="JJ/MM/AAAA"
                class="tranche-date-picker">
          </date-picker>
        </b-form-group>

        <b-form-group>
           <!-- Submit -->
          <b-button type="submit"
                    style="float: right;margin: 11px"
                    variant="primary"
                    :form="`tranche-form-${_uid}`">
              Sauvegarder
          </b-button>
        </b-form-group>
    </b-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Clone from 'clone';
import TrancheService from '../../services/TrancheService';
import CaseManagerService from '../../services/CaseManagerService';
import EnumerationService from '../../services/EnumerationService';

const $ = require('jquery');

const moment = require('moment');

export default {
  name: 'TrancheCreateType',
  props: {
    title: {
      type: String,
      default: 'Nouveau dossier',
    },
  },
  data() {
    return {
      agencies: [],
      tranche: {},
      ameoDateValid: true,
      caseManagerValid: true,
      agencyValid: true,
    };
  },
  computed: {
    ...mapGetters({
      userSession: 'getUserSession',
    }),
    config() {
      const size = this.getViewPortSize();
      return {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        locale: moment.locale('fr'),
        focusOnShow: false,
        ignoreReadonly: true,
        allowInputToggle: true,
        widgetPositioning: {
          horizontal: ['sm', 'xs'].indexOf(size) !== -1 ? 'right' : 'left',
        },
      };
    },
    caseManagers() {
      if (this.getCaseManagerList() === null || typeof this.getCaseManagerList() === 'undefined') {
        return [];
      }
      let list = Clone(this.getCaseManagerList());
      list = list.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
      });
      return list;
    },
  },
  methods: {
    ...mapGetters([
      'getTrancheStatusEnumeration',
      'getCaseManagerList',
      'getEnedisCaseOnGoing',
      'getViewPortSize',
      'getAgencies',
    ]),
    ...mapActions([
      'fetchAgencies',
    ]),
    formatCaseManagerName(caseManager) {
      return CaseManagerService.formatName(caseManager);
    },
    patchCreateTranche(event) {
      // Format tranche data to send
      const trancheForm = Clone(this.tranche);

      // Checking if required fields are populated, if not throw an error
      if (trancheForm.ameoDate == null) {
        this.ameoDateValid = false;
      } else {
        this.ameoDateValid = true;
      }

      if (trancheForm.caseManager == null) {
        this.caseManagerValid = false;
      } else {
        this.caseManagerValid = true;
      }

      if (trancheForm.agency == null) {
        this.agencyValid = false;
      } else {
        this.agencyValid = true;
      }

      if (this.ameoDateValid == false || this.caseManagerValid == false || this.agencyValid == false) {
        // Show error toast
        const toast = {
          show: true,
          message: 'Merci de remplir tous les champs obligatoires.',
          variant: 'danger',
          duration: 3000,
        };
        this.$store.commit('setGlobalToaster', toast);
        return;
      }

      // No needs to send collection, there are specials endpoints for that
      delete trancheForm.gapHistories;
      // No needs to send a null date
      if (trancheForm.ameoDate === null) {
        delete trancheForm.ameoDate;
      } else {
        // Format for server
        const format = trancheForm.ameoDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';
        trancheForm.ameoDate = moment(trancheForm.ameoDate, format).format('YYYY-MM-DD HH:mm');
      }
      // Id are auto increment, don't patch it
      if (typeof trancheForm.id !== 'undefined') {
        delete trancheForm.id;
      }
      // The back end will transform id in Agent entity
      trancheForm.caseManager = trancheForm.caseManager === null ? null : this.tranche.caseManager.id;

        if (this.isNew()) {
          // Creation

          // Date and case manager are mandatory
          if (trancheForm.ameoDate == null || trancheForm.caseManager == null || trancheForm.agency == null) {
            // Show error toast
            const toast = {
              show: true,
              message: 'Merci de remplir tous les champs obligatoires.',
              variant: 'danger',
              duration: 3000,
            };
            this.$store.commit('setGlobalToaster', toast);

            return;
          }

          let formData = new FormData();
          const formatAmeo = trancheForm.ameoDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';

          formData.append('ameoDate', moment(trancheForm.ameoDate, formatAmeo).format('YYYY-MM-DD HH:mm'));
          formData.append('caseManager', trancheForm.caseManager === null ? null : this.tranche.caseManager.id);
          formData.append('agency', trancheForm.agency);

          if (trancheForm.palRro != null) {
            formData.append('palRro', trancheForm.palRro);
          }

          if (trancheForm.classA != null) {
            formData.append('classA', trancheForm.classA);
          }

          if (trancheForm.completeDate != null) {
            const formatComplete = trancheForm.completeDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';
            formData.append('completeDate', moment(trancheForm.completeDate, formatComplete).format('YYYY-MM-DD HH:mm'));
          }

          if (trancheForm.receptionDate != null) {
            const formatComplete = trancheForm.receptionDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';
            formData.append('receptionDate', moment(trancheForm.receptionDate, formatComplete).format('YYYY-MM-DD HH:mm'));
          }

          axios.post(`tranches/${this.getEnedisCaseOnGoing().id}`, formData)
            .then((response) => {
              // Show success toast
              const toast = {
                show: true,
                message: 'Tranche créée avec succès !',
                variant: 'success',
                duration: 3000,
              };
              this.$store.commit('setEnedisCaseOnGoing', typeof response.data !== 'undefined' ? response.data : response);

              if (typeof response.data !== 'undefined') {
                this.$emit('updateTranches', response.data);
              }

              this.$store.commit('setGlobalToaster', toast);

              EnumerationService.setEnums(this.$store, {
                tranche: response.data._embedded.tranche_status_enumeration,
                trancheUpdate: response.data._embedded.tranche_update_status_enumeration,
              });
              this.$store.commit('setTrancheStatusEnumeration', EnumerationService.getEnum(response.data._embedded.tranche_status_enumeration));
              this.tranche = {};
            })
            .catch((error) => {
              console.error(error.message);
            });
        } else {
          // Patch
          const formatAmeo = trancheForm.ameoDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';

          let formData = {
            ameoDate: moment(trancheForm.ameoDate, formatAmeo).format('YYYY-MM-DD HH:mm'),
            caseManager: trancheForm.caseManager === null ? null : this.tranche.caseManager.id,
            palRro: trancheForm.palRro,
            classA: trancheForm.classA,
          };

          if (trancheForm.completeDate != null) {
            const formatComplete = trancheForm.completeDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';
            formData.completeDate = moment(trancheForm.completeDate, formatComplete).format('YYYY-MM-DD HH:mm');
          } else {
            formData.completeDate = null;
          }

          if (trancheForm.receptionDate != null) {
            const formatComplete = trancheForm.receptionDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';
            formData.receptionDate = moment(trancheForm.receptionDate, formatComplete).format('YYYY-MM-DD HH:mm');
          } else {
            formData.receptionDate = null;
          }

          axios.patch(`tranches/${this.tranche.id}`, formData)
              .then((response) => {
                // Show success toast
                const toast = {
                  show: true,
                  message: 'Tranche modifiée avec succès !',
                  variant: 'success',
                  duration: 3000,
                };
                this.$store.commit('setEnedisCaseOnGoing', typeof response.data !== 'undefined' ? response.data : response);
                // Emit event when tranche is created or updated
                this.$emit(typeof response.data !== 'undefined' ? 'created' : 'updated');
                this.$store.commit('setGlobalToaster', toast);
              })
              .catch((error) => {
                console.error(error.message);
              });
        }
    },
    archiveTranche() {
      if (this.isNew()) {
        return;
      }
      this.$store.commit('setGlobalSpinnerShow', true);
      // Prepare data
      const data = {
        form: {
          status: this.getTrancheStatusEnumeration().filter(s => s.value === 'STATUS_ARCHIVED')[0].text,
        },
        id: this.tranche.id,
      };
      this.$store.dispatch('patchTranche', data)
        .then((response) => {
          // console.log(response.data);
          // Show success toast
          const toast = {
            show: true,
            message: 'Tranche supprimée avec succès !',
            variant: 'success',
            duration: 3000,
          };
          this.$store.commit('setEnedisCaseOnGoing', response);
          // Emit event when tranche is created or updated
          this.$emit('archived');
          this.$store.commit('setGlobalToaster', toast);
        }, (error) => {
          console.log('Patch create tranche errro : ', error);
        })
        .finally(() => {
          this.$store.commit('setGlobalSpinnerShow', false);
        });
    },
    isNew() {
      return typeof this.tranche.id === 'undefined';
    },
  },
  beforeMount() {
    if (typeof this.getCaseManagerList() === 'undefined' || this.getCaseManagerList() === null) {
      this.$store.dispatch('getCaseManagers').then(() => {}, () => {});
    }
  },
  mounted() {
    // console.log('tranchetype mounted');
    if (this.isNew()) {
      // this.tranche.caseManager = this.userSession;
    } else if (this.tranche.ameoDate !== null && typeof this.tranche.ameoDate !== 'undefined') {
      this.tranche.ameoDate = moment(this.tranche.ameoDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
    }

    if (this.tranche.completeDate !== null && typeof this.tranche.completeDate !== 'undefined') {
      this.tranche.completeDate = moment(this.tranche.completeDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
    }

    if (this.tranche.receptionDate !== null && typeof this.tranche.receptionDate !== 'undefined') {
      this.tranche.receptionDate = moment(this.tranche.receptionDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
    }

    $(() => {
      // Set input date time picker to readonly because of the keyboard mobile event
      $('.ameo-date-group-input input').attr('readonly', 'readonly');
    });


    // Checking if agencies are in the Store. If not, fetch and store them
    if (this.getAgencies().length == 0) {
      this.$store.dispatch('fetchAgencies').then(() => { this.agencies = this.getAgencies(); });
    } else {
      this.agencies = this.getAgencies();
    }


  },
  destroyed() {
    // console.log('tranchetype destroyed');
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/TrancheCreateType.vue